import React from "react";
import "./page-layout.scss";

interface PageLayoutProps {
  children: React.ReactNode;
  centered?: boolean;
  fullHeight?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({ 
  children, 
  centered = false, 
  fullHeight = false,
}) => {
  return (
    <main 
      className={`page-layout ${centered ? "page-layout--centered" : ""} ${fullHeight ? "page-layout--full-height" : ""}`}
    >
      <div className="page-layout__container">{children}</div>
    </main>
  );
};

export default PageLayout;

